export default class Utils {
    static precision_round(number, precision) {
        let factor = Math.pow(10, precision);
        let tempNumber = number * factor;
        let roundedTempNumber = Math.round(tempNumber);
        return roundedTempNumber / factor;
    }

    static handleDecimals(original_value) {
        // Handle comma as decimal separator
        let value = original_value;
        let first = value.indexOf(",");
        if (first !== -1) {
            let part1 = value.substring(0, first + 1);
            let part2 = value.substring(first + 1);
            part2 = part2.replace(/[,]/g, "");

            value = part1 + part2;
        }
        value = value.replace(/[^0-9,]/g, "");
        return value;
    }

    static calculateAmountVATFromAmount(vat_comma, amount) {
        if (!amount) return "";

        let amount_vat = "";

        if (typeof vat_comma === 'undefined' || vat_comma === "") {
            vat_comma = "0";
        }

        let vat = parseFloat(vat_comma.replace(",", "."));

        if (!isNaN(vat)) {
            amount_vat = (1 + (vat / 100)) * amount;
            amount_vat = Utils.precision_round(amount_vat, 2);
            amount_vat = amount_vat + "";
            amount_vat = amount_vat.replace(".", ",");
        }

        return amount_vat;
    }

    static calculateAmountFromAmountVAT(vat_comma, amount_vat) {
        if (!amount_vat) return "";

        let amount = "";
        if (vat_comma !== undefined && vat_comma !== "") {
            let vat = parseFloat(vat_comma.replace(",", "."));
            if (!isNaN(vat)) {
                amount = amount_vat / (1 + (vat / 100));
                amount = Utils.precision_round(amount, 2);
                amount = amount + "";
                amount = amount.replace(".", ",");
            }
        }
        return amount;
    }

    static calculateAmountVATFromVAT(vat, amount_comma) {
        if (isNaN(vat)) {
            vat = 0.0;
        }
        let amount_vat = "";
        if (amount_comma !== undefined && amount_comma !== "") {
            let amount = parseFloat(amount_comma.replace(",", "."));
            amount_vat = (1 + (vat / 100)) * amount;
            amount_vat = Utils.precision_round(amount_vat, 2);
            amount_vat = amount_vat + "";
            amount_vat = amount_vat.replace(".", ",");
        }
        return amount_vat;
    }

    static calculateGuaranteeAmount(budget) {
        let guarantee_amount = "";
        if (!isNaN(budget)) {
            guarantee_amount = 0.05 * budget;
            guarantee_amount = Utils.precision_round(guarantee_amount, 2);
            guarantee_amount = guarantee_amount + "";
            guarantee_amount = guarantee_amount.replace(".", ",");
        }
        return guarantee_amount;
    }
}